import { amplitudeLib } from 'freedom-shared';

type FavoriteToggleSource = 'serp_page' | 'details_page';
type FavoritesListSource = 'tabbar' | 'main_page';
type FavoritesVariant = 'list_view' | 'direction_cards';

export const addToFavorites = (source: FavoriteToggleSource) => {
  amplitudeLib.logEvent('avfree_add_to_favorites', { source });
};

export const removeFromFavorites = (source: FavoriteToggleSource) => {
  amplitudeLib.logEvent('avfree_remove_from_favorites', { source });
};

export const favoritesPageOpen = (params: {
  variant: FavoritesVariant;
  source: FavoritesListSource;
  search_count: number;
  offer_count: number;
}) => {
  amplitudeLib.logEvent('avfree_favorites_page_open', params);
};

export const favoritesDirectionOpen = (params: {
  search_count: number;
  offer_count: number;
}) => {
  amplitudeLib.logEvent('avfree_favorites_direction_open', params);
};

export const favoritesOfferClick = (
  position: number,
  variant: FavoritesVariant,
) => {
  amplitudeLib.logEvent('avfree_favorites_offer_click', { position, variant });
};

export const favoritesSearchClick = (
  position: number,
  variant: FavoritesVariant,
) => {
  amplitudeLib.logEvent('avfree_favorites_search_click', { position, variant });
};
